import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'

Vue.use(Router)

let routes = []

// Domain auto registration
const requireDomains = require.context('./domains', false, /\.js$/)

requireDomains.keys().forEach(fileName => {
  if (fileName === './index.js') return

  const data = requireDomains(fileName).default

  if (data && Array.isArray(data)) { routes.push(...data) }
})

// Create Vue Router
let router = new Router({
  mode: 'history',
  routes: routes
})

// Create middleware
router.beforeEach((to, from, next) => {
  if (to.params.site) {
    axios.defaults.headers.common['X-Instance'] = to.params.site
  }

  if (!to.matched.length) {
    next('/404')
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js